"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _SNETDialogModule = _interopRequireDefault(require("./SNETDialog.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MobileDialog = _ref => {
  let {
    isDialogOpen,
    onDialogClose,
    title,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.Modal, {
    onClose: onDialogClose,
    open: isDialogOpen,
    children: /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: _SNETDialogModule.default.mobileDialog
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: _SNETDialogModule.default.titleMobileText
    }, title), /*#__PURE__*/_react.default.createElement(_material.Box, null, children))
  });
};
var _default = exports.default = MobileDialog;